// src/utils/schoolFlags.js
import { reactLocalStorage } from "reactjs-localstorage";

export const COLLEGE_SCHOOL_ID = "BQg48xBwCYY4O4hbZGC3";
export const SUNNAH_COLLEGE_SCHOOL_ID = COLLEGE_SCHOOL_ID;

function normalizeSchoolId(value) {
  return String(value || "").trim();
}

export function isCollegeSchool(schoolId = "") {
  const resolvedSchoolId = normalizeSchoolId(schoolId || reactLocalStorage.get("current-school"));
  return resolvedSchoolId === COLLEGE_SCHOOL_ID;
}

export function isSunnahCollegeSchool(schoolId = "") {
  return isCollegeSchool(schoolId);
}
